import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { ActivitiesCommunicationLogsRoutes } from '../../../routes/HomeRoutes/ActivitiesCommunicationLogsRoutes';

export const ActivitiesCommunicationLogsLayout = () => (
  <SwitchRoute routes={ActivitiesCommunicationLogsRoutes} />
);
